const ValidExtensionActions = require("../actions/ValidExtensionActions.js");

const ValidExtensionReducers = {
    [ValidExtensionActions.Get](prev, action) {
        let update = {
            AreLoading: true,
            Data: null,
            LoadError: null
        };

        return Object.assign({}, prev, {
            ValidExtensions: update
        });
    },
    [ValidExtensionActions.Got](prev, action) {
        let update = {
            AreLoading: false,
            Data: action.Data,
            LoadError: null
        };

        return Object.assign({}, prev, {
            ValidExtensions: update
        });
    },
    [ValidExtensionActions.GetErrored](prev, action) {
        let update = {
            AreLoading: false,
            Data: null,
            LoadError: action.Error
        };

        return Object.assign({}, prev, {
            ValidExtensions: update
        });
    }
};

module.exports = ValidExtensionReducers;


// WEBPACK FOOTER //
// ./src/reducers/ValidExtensionReducers.js